import React, { useEffect, useRef } from "react";
import { Button } from "reactstrap";
import { StateCallbacks } from "../state";

import "./../styles.scss";

interface IProps {
  canSave: boolean;
  canSubmit: boolean;
  disabled: boolean;
  onComplete: () => Promise<void>;
  onSave: () => Promise<void>;
  saving: boolean;
}

export const ActionToolbar = ({
  canSave,
  canSubmit,
  disabled,
  onComplete,
  onSave,
  saving,
}: IProps) => {
  const onSaveRef = useRef<HTMLButtonElement>(null);
  useEffect(() => {
    const keyDownListener = (e: KeyboardEvent) => {
      if (onSaveRef.current && e.key === "s" && e.ctrlKey) {
        e.preventDefault();
        onSaveRef.current.click();
      }
    };
    document.addEventListener("keydown", keyDownListener);
    return () => {
      document.removeEventListener("keydown", keyDownListener);
    };
  }, [onSaveRef.current]);
  let saveButtonContents = (
    <>
      <i className="fa fa-check mr-2" />
      Saved
    </>
  );
  if (saving) {
    saveButtonContents = (
      <>
        <i className="fa fa-spin fa-spinner mr-2" />
        Saving
      </>
    );
  } else if (canSave) {
    saveButtonContents = <>Save</>;
  }
  return (
    <div className="border-bottom p-2 float-right">
      <Button
        color="primary"
        disabled={disabled || saving || !canSave}
        innerRef={onSaveRef}
        onClick={onSave}
        title="Ctrl + S"
        type="button"
        outline={true}
      >
        {saveButtonContents}
      </Button>
      {' '}
      <Button
        color="primary"
        disabled={disabled || !canSubmit}
        onClick={e => {
          e.preventDefault();
          onComplete();
        }}
        type="submit"
      >
        Submit
      </Button>
    </div>   
  );
};
ActionToolbar.displayName = "ActionToolbar";
